import { SET_LOADER } from "../constats/loader.constant";

export const loaderReducer = (state={}, action) => {
    switch (action.type) {
        case SET_LOADER:
            return {
                loading: action.payload
            };
        default:
            return state;
    }
}